import React, { Component } from 'react'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import { autobind } from 'core-decorators'
import { Modal } from 'react-bootstrap/lib/'
import { observer } from 'mobx-react'
import GenevaButton from '../../shared/components/GenevaButton'

import './WarningDialog.scss'

interface IWarningProps extends InjectedIntlProps {
  show: boolean,
  handleClose: Function,
}
interface IState {
  show: boolean
}

@observer
class Warning extends Component<IWarningProps> {
  state: IState

  constructor(props: IWarningProps) {
    super(props)
    this.state = {
      show: (props && props.show) || false,
    }
  }

  componentDidMount() {
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) this.props.handleClose()
    })
  }

  @autobind
  closeWarningModal(): void {
    this.props.handleClose()
  }

  render() {

    return (
      <Modal
        show={this.state.show}
        onHide={this.closeWarningModal}
        dialogClassName="warningDialog"
      >

        <Modal.Body>
          <div className="warning-dialog-main grid-block">
            <div className="warning-dialog-title">
              <FormattedMessage id="warning-modal.title" />
            </div>
            <div className="warning-dialog-body">
              {/* todo: pass in value instead
              { this.props.message || '' } */}
              <FormattedMessage id="warning-modal.invalid-link-usage" />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <GenevaButton className="small button" onClick={this.closeWarningModal}>
            <FormattedMessage
              id="button.close"
            />
          </GenevaButton>
        </Modal.Footer>
      </Modal>)
  }
}

export default injectIntl(Warning)
